import { Injectable, Inject } from '@angular/core';
import { Observable, throwError, of } from "rxjs";
import 'rxjs/add/operator/map';
import 'rxjs/operator';
import 'rxjs/add/operator/catch';
import { HttpClient } from "@angular/common/http";
import { BaseService } from './BaseService';
import { IFormCaliforniaAssessmentTest } from "../Models/Forms/IFormCaliforniaAssessmentTest";

@Injectable()
export class FormCaliforniaAssessmentTestService extends BaseService {
  _baseUrl: string = "";

  constructor(protected _http: HttpClient, @Inject('BASE_URL') baseUrl: string) {
    super(_http);
    this._baseUrl = baseUrl;
  }

  getFormCaliforniaAssessmentTest(id: number) {
    return this._http.get(this._baseUrl + "api/FormCaliforniaAssessmentTest/" + id)
      .map((response: IFormCaliforniaAssessmentTest) => response as IFormCaliforniaAssessmentTest)
      .catch(this.errorHandler);
  }

  insertUpdateFormCaliforniaAssessmentTest(formCaliforniaAssessmentTestDetails: IFormCaliforniaAssessmentTest) {
    return this._http.post(this._baseUrl + 'api/FormCaliforniaAssessmentTest', formCaliforniaAssessmentTestDetails)
      .map((response: IFormCaliforniaAssessmentTest) => response as IFormCaliforniaAssessmentTest)
      .catch(this.errorHandler);
  }

  deletemCaliforniaAssessmentTest(id) {
    return this._http.delete(this._baseUrl + "api/FormCaliforniaAssessmentTest" + id)
      .map((response: IFormCaliforniaAssessmentTest) => response as IFormCaliforniaAssessmentTest)
      .catch(this.errorHandler)
  }

  errorHandler(error: Response) {
    console.log(error);
    return Observable.throw(error);
  }

}



